import { withStyles } from '@material-ui/core';

import IconTooltip from './component';
import styles from './styles';

export default withStyles(styles)(IconTooltip);
